<div class="footer">
  <ul>
    <li><img src="/assets/colbi-logo.png" alt="Colbi Technologies Inc." style="height: 1.5rem" /></li>
    <li>Copyright {{ currentYear() }}&copy; by Colbi Technologies Inc.&trade;</li>
    <li>All Right Reserved</li>
    <li>Privacy Policy</li>
    <li>Release of Liability</li>
    <li>Help</li>
  </ul>
</div>
